import React from "react";
import PropTypes from "prop-types";

const ItemMenuDomains = ({ link, handleClick, isMobile }) => {
  const { url, title, extraClass, image } = link;
  const ariaLabel = { "aria-label": 'Filter by ' + title };
  const additionalClass = extraClass || "";
  const linkClass = `sub-link sub-link--title-image sub-link--domain-filter d-block mt-12 mb-12 ${additionalClass}`;
  return (
    <>
    {isMobile &&
        <a
            href={url}
            className={`${linkClass} link--with-children`}
            onClick={(event) => {
            event.preventDefault();
            handleClick(title, url);
            }}
            role="menuitem"
        >
            {title}
      </a>
    }
    {!isMobile &&
        <button
        className={linkClass}
        {...ariaLabel}
        onClick={() => handleClick(title, url)}
        >
            <div className={`img-text img-text--clickable align-items-center`}>
                {image && (
                <div class="image-text__media-wrapper">
                    <div
                        className="img-text__media mr-8"
                        /* eslint-disable-next-line react/no-danger */
                        dangerouslySetInnerHTML={{
                        __html: image,
                        }}
                    />
                    <div class="domain-hover-overlay text-align-center">
                        <span>Filter by {title}</span>
                    </div>
                </div>
                )}

                <div className="img-text__text mr-8">
                <p className="img-text__title mb-0">{title}</p>
                </div>
            </div>
        </button>
    }
    </>
  );
};

ItemMenuDomains.defaultProps = {
  handleClick: () => {},
};

ItemMenuDomains.propTypes = {
  link: PropTypes.object.isRequired,
  handleClick: PropTypes.func,
};

export default ItemMenuDomains;
